import React, { useEffect, useState, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import { UncontrolledTooltip } from 'reactstrap/lib'
import _ from 'lodash'

import './styles.scss'
import { getBotId } from 'utils/helpers'
import { channelName, getChannelKey } from 'constants/channels'

const headerQr = [
  { label: 'dashboard_channel', value: 'channel', filter: 'desc' },
  { label: 'dashboard_brand', value: 'brand', filter: null },
  { label: 'dashboard_delegation', value: 'delegation', filter: null },
  { label: 'dashboard_identifier', value: 'botId', filter: null },
]

const headerAocs = [
  { label: 'dashboard_channel', value: 'channel', filter: 'desc' },
  { label: 'dashboard_brand', value: 'brand', filter: null },
  { label: 'dashboard_delegation', value: 'delegation', filter: null },
  { label: 'dashboard_identifier', value: 'botId', filter: null },
  { label: 'channels_showMobile', value: 'showMobile', filter: null },
  { label: 'channels_showDesktop', value: 'showDesktop', filter: null },
]

const ChannelList = (props) => {
  const {
    availableChannels, modalKey, onSelected, maxChannels, selectedChannels
  } = props

  const [channels, setChannels] = useState([])
  const [headers, setHeaders] = useState(modalKey === 'aocs' ? headerAocs : headerQr)

  useEffect(
    () => {
      orderBody(
        availableChannels.filter(e => !!e.url),
        {
          label: 'channels_channel',
          value: 'channel',
          filter: 'desc'
        }
      )
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availableChannels]
  )

  const orderBody = useCallback(
    (_channelsList, _header) => {
      const _channels = _.cloneDeep(_channelsList)

      if (_header.value === 'channel')
        setChannels(_channels.sort((a, b) => _header.filter === 'asc' ? a.key.localeCompare(b.key) : a.key.localeCompare(b.key)*-1 ))
      else if (_header.value === 'brand')
        setChannels(_channels.sort((a, b) => _header.filter === 'asc' ? a.brandName.localeCompare(b.brandName) : a.brandName.localeCompare(b.brandName)*-1 ))
      else if (_header.value === 'delegation')
        setChannels(_channels.sort((a, b) => _header.filter === 'asc' ? a.delegationName.localeCompare(b.delegationName) : a.delegationName.localeCompare(b.delegationName)*-1 ))
      else if (_header.value === 'botId')
        setChannels(_channels.sort((a, b) => _header.filter === 'asc' ? a.value.botId.localeCompare(b.value.botId) : a.value.botId.localeCompare(b.value.botId)*-1 ))
    }, []
  )

  const orderBy = (_header) => {
    if (_header.value !== 'showIn') {
      _header.filter = _header.filter ? (_header.filter === 'asc' ? 'desc' : 'asc') : 'asc'
      const _headers = _.clone(headers)
      _headers.forEach(it => {
        it.filter = it.value === _header.value ? _header.filter : null
      })
      setHeaders(_headers)

      orderBody(channels, _header)
    }
  }

  const onActive = async (channel) => {
    const _channels = _.cloneDeep(channels)

    _channels.forEach(it => {
      if (it._id === channel._id) {
        it.isChecked = !it.isChecked
        it.isDesktop = true
        it.isMobile = true
      }
    })

    channel.isChecked = !channel.isChecked
    channel.isDesktop = true
    channel.isMobile = true

    setChannels(_channels)

    if (onSelected) {
      if (channel.isChecked) {
        onSelected(
          [].concat(selectedChannels.filter(e => e._id !== channel._id))
            .concat(channel)
        )
      } else {
        onSelected(
          [].concat(selectedChannels.filter(e => e._id !== channel._id))
        )
      }
    }
  }

  const onChange = (channel, type) => {
    const _channels = _.cloneDeep(channels)

    if (type === 'mobile') {
      channel.isMobile = !channel.isMobile

      _channels.forEach(it => {
        if (it._id === channel._id) {
          it.isMobile = !it.isMobile
        }
      })
    } else {
      channel.isDesktop = !channel.isDesktop

      _channels.forEach(it => {
        if (it._id === channel._id) {
          it.isDesktop = !it.isDesktop
        }
      })
    }

    setChannels(_channels)

    if (channel.isChecked && onSelected) {
      onSelected(
        [
          ...selectedChannels.filter(e => e._id !== channel._id),
          channel
        ]
      )
    }
  }

  return (
    <div className='channel-list'>
      <div className='header-row-2'>
        <div className='check-column' />
        {
          headers.map((elem) => (
            <div key={elem.value} className={elem.value}>
              { (elem.value === 'showMobile' || elem.value === 'showDesktop') ?
                <>
                  { elem.value === 'showMobile' ?
                    <i className='fa fa-mobile fa-lg' style={{ marginLeft: '2px' }} /> :
                    <i className='fa fa-laptop fa-lg' style={{ marginLeft: '2px' }} />
                  }
                </>
                :
                <>
                  <span
                    onClick={() => orderBy(elem)}
                  >
                    {I18n.t(elem.label)}
                  </span>
                  {elem.filter && <img src='img/icons/icon-expand.svg' alt='expand' className={`${elem.filter}`}/>}
                </>
              }
            </div>
          ))
        }
      </div>
      <div className='body-row-list-2'>
        <div className='separator' />
        {channels.map((dChannel, idx) => {
          const channel = selectedChannels.find(ch => ch._id === dChannel._id) || dChannel

          const isChannelTypeUsed = selectedChannels.find(ch => getChannelKey(ch.key) === getChannelKey(channel.key)) && !channel.isChecked && channel.key !== 'wall'
          const appsApiWithoutUrl = channel.key === 'wall' && ['android_api', 'ios_api'].includes(channel.value?.connectionType) && !channel.url
          const rowDisabled = !channel.isChecked && (isChannelTypeUsed || selectedChannels.length > maxChannels || appsApiWithoutUrl)

          return (
            <div
              key={idx}
              className='body-row animated fadeIn'
              style={{ opacity: rowDisabled ? 0.5 : 1 }}
            >
              <div className='content-container'>
                <div className='fields' id={`${channel.key}-${channel._id}`}>
                  <div
                    className='check'
                    style={{
                      backgroundColor: channel.isChecked ? '#dd601d' : '#FFFFFF',
                      pointerEvents: rowDisabled ? 'none' : 'auto'
                    }}
                    onClick={() => onActive(channel, idx)}
                  >
                    { channel.isChecked ?
                      <img src='img/icons/icon-check.svg' alt="Check" /> : null
                    }
                  </div>
                  { appsApiWithoutUrl &&
                    <UncontrolledTooltip placement='top' target={`${channel.key}-${channel._id}`}>
                      {I18n.t('channels_apps_api_no_deeplink')}
                    </UncontrolledTooltip>
                  }
                  <span className='channel-name channel'>
                    {
                      channel.key === 'wall'
                        ? channel.value.connectionType
                          ? I18n.t(channelName[channel.value.connectionType].name)
                          : I18n.t(channelName[channel.key].name)
                        : channel.hub === 'whatsapp'
                          ? I18n.t(channelName[`${channel.hub}_${channel.key}`].name)
                          : I18n.t(channelName[channel.key].name)

                    }
                  </span>
                  <span className='brand'>{channel.brandName}</span>
                  <span className='delegation'>{channel.delegationName}</span>
                  <span className='botId'>{getBotId(channel) || ''}</span>
                  { modalKey === 'aocs' ?
                    <>
                      <span className='showMobile'>
                        <div
                          className='check-show'
                          style={{
                            backgroundColor: channel.isChecked ? (channel.isMobile ? '#dd601d' : '#FFFFFF') : 'grey',
                            pointerEvents: rowDisabled ? 'none'  : 'auto',
                            opacity: channel.isChecked ? 1 : 0.5
                          }}
                          onClick={() => onChange(channel, 'mobile')}
                        >
                          { (channel.isChecked && channel.isMobile) ?
                            <img src='img/icons/icon-check.svg'  alt="Check" /> : null
                          }
                        </div>
                      </span>
                      <span className='showDesktop'>
                        <div
                          className='check-show'
                          style={{
                            backgroundColor: channel.isChecked ? (channel.isDesktop ? '#dd601d' : '#FFFFFF') : 'grey',
                            pointerEvents: rowDisabled ? 'none'  : 'auto',
                            opacity: channel.isChecked ? 1 : 0.5
                          }}
                          onClick={() => onChange(channel, 'desktop')}
                        >
                          { (channel.isChecked && channel.isDesktop) ?
                            <img src='img/icons/icon-check.svg'  alt="Check" /> : null
                          }
                        </div>
                      </span>
                    </>
                    : null
                  }
                </div>
              </div>
              <div className='separator' />
            </div>
          )})}
      </div>
    </div>
  )
}

export default ChannelList
